import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const simplifyPickupBopisHeaderTextPdpSelector = createSelector(
    testTargetOffersSelector,
    offers => offers.simplifyPickupBopisHeaderTextPdp || Empty.Object
);

export { simplifyPickupBopisHeaderTextPdpSelector };
